export default __webpack_public_path__ + "static/splash-cdadaec9c375d7c2449737b60ed81581.png";